import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { serviceCenterStore } from 'App/ServiceCenter/store/serviceCenterStore'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import { apiFetch } from 'utils/apiFetch'
import { parse as parseWKT } from 'wellknown'

export type NodeReplanMeta = routes.ServiceCenterNodeReplan.Request

export type NodeReplanResponse = routes.ServiceCenterNodeReplan.Response

export const request = async (param: NodeReplanMeta): Promise<NodeReplanResponse> => {
  return apiFetch({ url: '/service-center-node-replan', body: param })
}

export const callback = async (response: NodeReplanResponse, param: NodeReplanMeta) => {
  serviceCenterStore.actions.removeActiveNodes(param.nodeIdentifiers)

  const shapedPlannedNodes = response.map((pnode) => ({
    ...pnode,
    id: String(pnode.pseudonodeId),
    location: JSON.stringify(parseWKT(pnode.location as string)),
    blockId: null,
    pseudogatewayId: pnode.pseudogatewayId || undefined,
    gatewayMac: pnode.gatewayMac || undefined,
  }))

  serviceCenterStore.actions.updatePlannedNodes(shapedPlannedNodes)

  const plannedNodes = serviceCenterStore.selectors.getPlannedNodesForSelectedProperties(
    serviceCenterStore.getState(),
    selectedFieldAssetsStore.getState().property,
  )

  // Filter out planned nodes with negative pseudonodeIds (which were created as placeholders in the UI when the node was replan while offline)
  const temporaryPlannedNodeIds = plannedNodes.filter((node) => Number(node.id) < 0).map((node) => node.id)

  serviceCenterStore.actions.removePlannedNodes(temporaryPlannedNodeIds)
}

export const serviceCenterNodeReplan = {
  request,
  callback,
}
